import { isEmpty } from "cxa-utils";

/*
API's are expected throw 400 / 404 if a resource does not exist or inaccessible.
But some API may return status 200 and an empty object "{}".

Attach this rule to a Promise in order to reject empty object even though the API
  returns status 200.

e.g.
<promise>
  .then(ruleRejectResponseEmptyObject)
  .catch(yourCatchHandler);

*/
export const ruleRejectResponseEmptyObject = r => {
  if (isEmpty(r.body)) {
    // eslint-disable-next-line
    throw "ruleRejectResponseEmptyObject failed";
  }

  return r;
};

/*
In the event that the response data is in different formats, sanitize it here.
Usually attached in the Promise.catch().
e.g.
<promise>.catch(e => resolveResponseError)
*/
export const resolveResponseError = err => {
  let text;
  let data;

  if (err.response) {
    // TODO: There is too much info in a Response object.  Not sure yet which attributes
    //       are most likely interesting so temporarily save the whole thing
    if (err.response.type === "application/json") {
      text = JSON.parse(err.response.text).message;
    } else {
      text = err.response.text;
    }
    data = err.response;
  } else {
    text = err;
    data = err;
  }

  return {
    orig: err,
    text,
    data,
  };
};

/*
Usually attached after the Promise.catch() is resolved with resolveResponseErro().
e.g.
<promise>
    .catch(e => resolveResponseError)
    .then(e => captureResponseToDispatch(dispatch, "messageLocaleKey", "/some/resource"))

Note: The <captureAction> will recieve {msg, data} as arguments.
 */
export const captureErrorToDispatch = (
  dispatcher,
  captureAction,
  actionOptionalData
) => errdata => {
  dispatcher(
    captureAction.call(null, {
      msg: errdata.text,
      data: actionOptionalData,
    })
  );
};



// WEBPACK FOOTER //
// ./api/promise-helpers.js